<div class="flex flex-col gap-5">
  <app-panel titleKey="project.steps.rfq.invitationPreview.system.current" [collapsed]="true">
    <app-step-3-1-system-overview [officeSystemRecording]="currentOfficeSystemRecording()" />
  </app-panel>

  <app-panel titleKey="project.steps.rfq.invitationPreview.system.target" [collapsed]="true">
    <app-step-3-1-system-overview [officeSystemRecording]="targetOfficeSystemRecording()" />
  </app-panel>

  <app-panel titleKey="project.steps.rfq.invitationPreview.system.integration" [collapsed]="true">
    <app-system-flow
      [projectId]="projectId()"
      [integrationSystemRecordings]="integrationSystemRecordings()"
      [isReadOnly]="true"
    />
  </app-panel>
</div>
